/**
 * Created by jv on 2019-10-17 (10:41).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");

require("Styles/components/business-model-dialog.scss");
require("Styles/components/faq-dialog.scss");

class FaqDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("faq-dialog-");

    this.faqItems = options.faqItems;
    this.investments = options.investments;
    this._faqType = options.faqType;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
    this.onViewInvestment = options.onViewInvestment;
  }

  get faqType() {
    return this._faqType;
  }

  set faqType(faqType) {
    this._faqType = faqType;
    this.renderDialogContent();
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog faq-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.faqType)) return;

    let faqItem = this.getFaqItemForType();

    if (utils.isNull(faqItem)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up faq dialog - %o", faqItem);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $faqContent = $("<div class='faq-dialog__content'></div>");

      let investment = null;

      if (utils.isNotNull(faqItem.investmentKey)) {
        investment = this.getInvestmentForFaqItem(faqItem);

        /*if(utils.isNotNull(investment))
        {
          let $faqTop = $("<div class='faq-dialog__top'></div>");

          // TODO icon
          $faqTop.append(`<h6 class='faq-dialog__title'>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.title")}</h6>`);

          $faqContent.append($faqTop);
        }*/
      }

      let $faqBottom = $("<div class='faq-dialog__bottom'></div>");

      $faqBottom.append(`<div class="faq-dialog__text">${faqItem.description}</div>`);

      if (utils.isNotNull(faqItem.investmentKey) && utils.isNotNull(investment)) {
        let $faqActions = $("<div class='faq__actions'></div>");

        let $viewInvestmentButton = $(`<button class='btn btn-outline-c-light-blue btn-lg view-investment-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.faq.dialog.actions.investment")}</button>`);

        $viewInvestmentButton.on("click", (e) => {
          if (utils.isFunction(this.onViewInvestment)) {
            this.onViewInvestment.call(this.callbackContext, this, investment);
          }
        });

        $faqActions.append($viewInvestmentButton);

        $faqBottom.append($faqActions);
      }

      $faqContent.append($faqBottom);

      $dialogContent.append($faqContent);

      this.setUpEventListeners();
    }
  }

  show() {
    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });
  }

  getInvestmentForFaqItem(faqItem) {
    if (utils.isNull(faqItem.investmentKey)) return null;
    if (utils.isNull(this.investments)) return null;

    for (let i = 0; i < this.investments.length; i++) {
      if (this.investments[i].key === faqItem.investmentKey) {
        return this.investments[i];
      }
    }

    return null;
  }

  getFaqItemForType() {
    for (let i = 0; i < this.faqItems.length; i++) {
      if (this.faqType === this.faqItems[i].type) {
        return this.faqItems[i];
      }
    }

    return null;
  }
}

export default FaqDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/faq-dialog.js